import { render, staticRenderFns } from "./All-Users.vue?vue&type=template&id=0b6b800f&"
import script from "./All-Users.vue?vue&type=script&lang=js&"
export * from "./All-Users.vue?vue&type=script&lang=js&"
import style0 from "./All-Users.vue?vue&type=style&index=0&id=0b6b800f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports